<div class="view-tour-success" [class.view-tour-success--inline]="inline">

    <app-icon class="view-tour-success__icon" icon="check">
    </app-icon>

</div>
